import { render, staticRenderFns } from "./ForgetResetComponent.vue?vue&type=template&id=a0166ece&scoped=true&"
import script from "./ForgetResetComponent.vue?vue&type=script&lang=js&"
export * from "./ForgetResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgetResetComponent.vue?vue&type=style&index=0&id=a0166ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0166ece",
  null
  
)

export default component.exports